module.exports = {"data":{"site":{"siteMetadata":{"title":"Notebook"}},"allMarkdownRemark":{"edges":[{"node":{"excerpt":"As is customary, we start off with a friendly “hello, world”! I’m planning to use this as a notebook to discuss ideas and projects. I think\nthat fits the definition of a “blog”, but I’d prefer not to use the term\n“blog”, so let’s call this a notebook instead. Intended audience…","frontmatter":{"title":"Hello, world","date":"27 January, 2018"},"fields":{"id":"/2018-01-27-hello-world/","path":"/2018/01/27/hello-world"}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 435
// module chunks = 142629428675168